import { render, staticRenderFns } from "./ApprovalType.vue?vue&type=template&id=06cd3fc1"
import script from "./ApprovalType.vue?vue&type=script&lang=js"
export * from "./ApprovalType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports